import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/statement-positive.svg";
var StatementPositiveSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  StatementPositiveSolid_default as default
};
